import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { agentsData } from "Stores/agentsData";
import AgentSelect from "./AgentSelect";
import { eventFilters, filterOptions, filterValueLabel } from "./triggerCatalog";

// Narrows an event trigger: "only when the new stage is Working", "only in these sequences", "only
// when it ends without a reply". Nothing picked = react to every such event, which is what agents
// did before filters. Values are the team's own stages, fields and sequences — nothing to type wrong.

const TriggerFilters = observer(({ eventType, config = {}, onChange }) => {
  const filters = eventFilters(eventType);
  const needsStages = filters.some(f => f.valueType === "contactStage");
  const needsFields = filters.some(f => f.valueType === "contactField");
  const needsSequences = filters.some(f => f.valueType === "sequence");

  useEffect(() => {
    if (needsStages && !agentsData.contactStages.length) agentsData.fetchContactStages();
    if (needsFields && !agentsData.contactFields.length) agentsData.fetchContactFields();
    if (needsSequences && !agentsData.sequencesLite.length) agentsData.fetchSequencesLite();
  }, [needsStages, needsFields, needsSequences]);

  if (!filters.length) return null;

  const set = (key, values) => onChange({ ...config, [key]: values });

  return (
    <div className="ag-tfilters">
      {filters.map(f => {
        const picked = Array.isArray(config[f.key]) ? config[f.key] : [];
        const options = filterOptions(f).filter(o => !picked.includes(o.value));
        const labelOf = value => filterValueLabel(f, value);
        return (
          <div className="ag-field" key={f.key}>
            <span className="ag-field__label">
              {f.label} <span className="ag-tfilters__opt">optional</span>
            </span>
            {picked.length > 0 && (
              <span className="ag-tfilters__chips">
                {picked.map(v => (
                  <span className="ag-tfilters__chip" key={v}>
                    {labelOf(v)}
                    <button type="button" onClick={() => set(f.key, picked.filter(x => x !== v))}
                      aria-label={`Remove ${labelOf(v)}`}>
                      <i className="material-icons-outlined">close</i>
                    </button>
                  </span>
                ))}
              </span>
            )}
            <AgentSelect value="" searchable options={options}
              placeholder={picked.length ? "Add another…" : "Any, leave blank to run on all"}
              onChange={v => v && set(f.key, [...picked, v])} />
          </div>
        );
      })}
    </div>
  );
});

export default TriggerFilters;
